var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5156 0H2.48438C1.11188 0 0 1.13658 0 2.53958V43.4623C0 44.8634 1.11188 46 2.48438 46H24.0375V28.1865H18.1725V21.2443H24.0375V16.1249C24.0375 10.1833 27.5869 6.94792 32.7731 6.94792C35.2575 6.94792 37.3913 7.13767 38.0138 7.222V13.432L34.4175 13.4339C31.5975 13.4339 31.0519 14.8043 31.0519 16.813V21.2463H37.7775L36.9019 28.1884H31.0519V46H42.5194C43.8881 46 45 44.8634 45 43.4604V2.53958C45 1.13658 43.8881 0 42.5156 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6f9cc35135a2d37271a2825a10db3f91.svg";
export { ForwardRef as ReactComponent };